export default import.meta.ROLLDOWN_FILE_URL_8B71$4ec1J6Po6IJYp4VSw